import { FC, createContext, useContext, ReactNode } from 'react';

import { TAIForm } from 'src/types';

export interface AIFormContextType {
  data: Nullable<TAIForm>;
}

export const AIFormContext = createContext<AIFormContextType>(undefined!);

interface AIFormProviderProps {
  data: TAIForm;
  children: Nullable<ReactNode>;
}

export const AIFormProvider: FC<AIFormProviderProps> = ({ data, children }) => {
  return (
    <AIFormContext.Provider
      value={{
        data,
      }}>
      {children}
    </AIFormContext.Provider>
  );
};

export const useAIForm = () => {
  return useContext(AIFormContext);
};
